import { render, staticRenderFns } from "./listadoFicha.vue?vue&type=template&id=ad1ef92a&scoped=true"
import script from "./listadoFicha.vue?vue&type=script&lang=js"
export * from "./listadoFicha.vue?vue&type=script&lang=js"
import style0 from "./listadoFicha.vue?vue&type=style&index=0&id=ad1ef92a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad1ef92a",
  null
  
)

export default component.exports